<template>
  <div class="alert-box">
    <el-alert
      type="info"
      :closable="false">
      <template slot="title">
        <div class="title-wrapper">
          <p class="title">{{title}}</p>
          <el-button class="btn" v-if="btnText" type="text" size="mini" @click="handleBtnClick">{{btnText}}</el-button>
        </div>
      </template>
    </el-alert>
  </div>
</template>

<script>
export default {
  props: {
    // 提示文案
    title: {
      type: String,
      default: '',
    },
    // 按钮文案
    btnText: {
      type: String,
      default: '',
    },
  },
  methods: {
    handleBtnClick() {
      this.$emit('btnClick')
    },
  },
}
</script>

<style lang="scss" scoped>
.alert-box {
  ::v-deep .el-alert {
    display: flex;
    align-items: center;
    height: 46px;
    padding: 12px 16px;
    border: none;
    box-sizing: border-box;
    .el-alert__icon {
      align-self: auto;
      margin-top: 0;
      font-size: 18px;
    }
    .el-alert__content {
      padding: 0;
    }
  }
  .title-wrapper {
    display: flex;
    margin-left: 10px;
    .title {
      font-size: 14px;
      font-weight: 400;
      color: #303133;
    }
    .btn {
      margin-left: 10px;
    }
  }
}
</style>
